import { useEffect } from 'react';
import { useBranding } from '@/hooks/useBranding';

/**
 * Titre d'onglet suffixé par la marque du tenant (white-label) — le suffixe
 * « CarrierBridge » codé en dur fuyait la marque par défaut chez les clients
 * en marque blanche (onglets, favoris, historique).
 */
export function usePageTitle(title: string) {
  const { data: branding } = useBranding();
  const brand = branding?.brandName || 'CarrierBridge';

  useEffect(() => {
    document.title = title ? `${title} — ${brand}` : brand;
  }, [title, brand]);
}
